import React from 'react';
import { CommonUtil } from '../../utils/CommonUtil';
import { Constants } from '../Languages/Constants';
import CheckAvailabilityPreview from './CheckAvailabilityPreview';
import FlatpickrField from '../../Components/FlatpickrField';
import InputField from '../../Components/InputField';

const ExtendReservationModal = ({
  reservationStartDate,
  reservationEndDate,
  maxReservationEndDate,
  dateOptions,
  fromRef,
  toRef,
  onChangeFromDate,
  onChangeToDate,
  activationDate,
  isDateChanged,
  etype,
  activationEngineHours,
  lastEngineHour,
  exEngineHours,
  onChangeEngineHours,
  activationOdometer,
  lastHubodometer,
  enteredHubodometer,
  onChangeHubodometer,
  allInvoices,
  onCancel,
  onSave,
}: any) => {
  const reservationEndLimit = maxReservationEndDate ? new Date(maxReservationEndDate) : null;
  const minExtendToDate = reservationEndLimit && !Number.isNaN(reservationEndLimit.getTime())
    ? new Date(reservationEndLimit.getFullYear(), reservationEndLimit.getMonth(), reservationEndLimit.getDate() + 1)
    : undefined;

  const toDateOptions = {
    ...(dateOptions || {}),
    minDate: minExtendToDate,
  };

  return (
    <div
      className="d-flex flex-column overflow-hidden"
      style={{ height: 'calc(100vh - 80px)', margin: '-16px -16px 0 -16px', paddingBottom: 0 }}
    >
      <div className="row pb-3 pt-3 px-3 pt-0 bg-white border-bottom shadow-sm">
        <div className="row col-12 flex-nowrap align-items-end pt-2">
          <div className="col-2 col-md-2 flex-shrink-0 my-1">
              <FlatpickrField
                placeholder="From Date"
                ref={fromRef}
                options={dateOptions}
                onChange={onChangeFromDate}
                defaultValue={CommonUtil.getDateFormatForDatePicker(reservationStartDate)}
                disabled={
                  activationDate
                    ? true
                    : isDateChanged
                      ? CommonUtil.ORGANIZATION_TYPE === CommonUtil.ORG_TYPE_RENTER
                      : true
                }
              />
          </div>

          <div className="col-2 col-md-2 flex-shrink-0 my-1">
              <FlatpickrField
                placeholder="To Date"
                ref={toRef}
                options={toDateOptions}
                onChange={onChangeToDate}
                defaultValue={CommonUtil.getDateFormatForDatePicker(reservationEndDate)}
                disabled={!isDateChanged}
              />
          </div>

          {etype && activationEngineHours ? (
            <>
              <div className="col-2 col-md-2 flex-shrink-0 my-1">
                <InputField
                  placeholder="Last Engine hours"
                  type="text"
                  value={lastEngineHour || activationEngineHours}
                  disabled
                />
              </div>

              <div className="col-2 col-md-2 flex-shrink-0 my-1">
                <InputField
                  placeholder="Engine Hours"
                  type="text"
                  value={exEngineHours}
                  onChange={(e: any) => {
                    onChangeEngineHours(e.currentTarget.value);
                  }}
                />
              </div>
            </>
          ) : (
            ''
          )}

          {activationOdometer ? (
            <>
              <div className="col-2 col-md-2 flex-shrink-0 my-1">
                <InputField
                  placeholder="Last Hubodometer"
                  type="text"
                  value={lastHubodometer || activationOdometer}
                  disabled
                />
              </div>
              <div className="col-2 col-md-2 flex-shrink-0 my-1">
                <InputField
                  placeholder="Hubodometer value"
                  type="text"
                  value={enteredHubodometer}
                  onChange={(e: any) => {
                    onChangeHubodometer(e.currentTarget.value);
                  }}
                />
              </div>
            </>
          ) : (
            ''
          )}
        </div>
      </div>

      <div className="flex-grow-1 overflow-auto bg-light px-3 py-3" style={{ minHeight: 0 }}>
        {allInvoices.length > 0 ? (
          <CheckAvailabilityPreview data={allInvoices} defaultCollapsed={true} />
        ) : (
          <div className="text-center py-5 mt-5">
            <h5 className="text-muted">No invoices found for this reservation.</h5>
          </div>
        )}
      </div>

      <div
        className="d-flex bg-white border-top justify-content-end align-items-center gap-2 px-3 pt-3 pb-0 mt-auto"
        style={{ marginBottom: 0, flexShrink: 0 }}
      >
        <button type="button" className="btn btn-outline-dark" onClick={onCancel}>
          {CommonUtil.getMessageText(Constants.CLOSE, 'Cancel')}
        </button>
        <button type="button" className="btn btn-success" onClick={onSave}>
          {CommonUtil.getMessageText(Constants.SAVE, 'Save')}
        </button>
      </div>
    </div>
  );
};

export default ExtendReservationModal;
